import React from "react";
import {
    Navbar,
    NavLeft,
    NavTitle,
    Page,
    List,
    ListItem,
    Popup,
    NavRight,
    Link,
} from "framework7-react";
import iride_logo from "../assets/iride_logo.png";
import Mezzi from "../entities/Mezzi";
import IWAjax from "../utils/IWAjax";

export default class Giacenza extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            camion: localStorage.getItem("camion") || "",
            mezzo: {codice: ""},
            user: JSON.parse(localStorage.getItem("user")),
            qtot: 0,
            giacenza_tipo_bins: [],
        }
    }

    async componentDidMount() {
        const self = this;
        const app = self.$f7;
        const m = await new Mezzi();
        m.getById(self.state.camion).then(r => {
            this.setState({"mezzo": r}, () => {
                IWAjax({
                    app: app,
                    route: 'getGiacenzaMagazzino',
                    data: {idmagazzino: r._id},
                    showPreloader: false,
                    success: function (res) {
                        let giacenza = res.data;
                        let bins_giacenza = [];
                        let nbins = 0;
                        if (giacenza !== null) {
                            // eslint-disable-next-line array-callback-return
                            giacenza.map((elem, index) => {
                                bins_giacenza.push(elem);
                                nbins += parseInt(elem.q);
                            });
                        }
                        self.setState({
                            giacenza_bins: bins_giacenza,
                            qtot: nbins,
                        }, () => self.updateBinsList());
                    },
                    error: function (err) {
                        console.log(err)
                    }
                });
            });
        });
    }

    updateBinsList() {
        const self = this;
        let cassoni = [];
        cassoni = self.state.giacenza_bins;
        let bins = {};
        cassoni.forEach(function (riga) {
            bins[riga.id] = {
                "descrizione": riga.descrizione,
                "q": riga.q,
            }
        });
        self.setState({giacenza_tipo_bins: bins});
    }

    render() {
        const self = this;
        const {giacenza_tipo_bins} = self.state;

        return (
            <Page name={"Giacenza"}>
                <Navbar>
                    <NavLeft backLink="Back" backLinkForce backLinkUrl={"/home/"}/>
                    <NavTitle><img src={iride_logo} alt='logo'
                                   height="30rem"/>{"Giacenza Camion " + self.state.mezzo.codice}</NavTitle>
                </Navbar>
                <List>
                    <ListItem title="Camion" after={self.state.mezzo.descrizione}/>
                    <ListItem title={"Autista"} after={self.state.user.username}/>
                    <ListItem title="Giacenza" badge={self.state.qtot}
                              popupOpen="#giacenza_list-popup"
                              link={"#"}/>
                </List>
                <Popup id={"giacenza_list-popup"}>
                    <Page>
                        <Navbar
                            title={"Giacenza Bins"}>
                            <NavRight>
                                <Link popupClose>Chiudi</Link>
                            </NavRight>
                        </Navbar>
                        <List>
                            {Object.keys(giacenza_tipo_bins).map((giacenza_tipo_bin, index) => (
                                <ListItem title={giacenza_tipo_bins[giacenza_tipo_bin].descrizione}
                                          badge={giacenza_tipo_bins[giacenza_tipo_bin].q}
                                          key={index}>
                                </ListItem>
                            ))}
                        </List>
                    </Page>
                </Popup>
            </Page>
        )
    }
}
